import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Trash2, Clock } from 'lucide-react';
import { getAuthHeader } from '../../services/tokenService';
import { useAuth } from '../../contexts/AuthContext';
import { Badge } from '../ui/badge';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/recus-ess`;

export default function EcheancesRecuValide({ recuId }) {
  const { user } = useAuth();
  const [echeances, setEcheances] = useState([]);
  const peutSupprimer = ['admin', 'super_admin'].includes(user?.role);

  const charger = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/${recuId}/echeancier`, { headers: getAuthHeader() });
      setEcheances(data.echeances || []);
    } catch { setEcheances([]); }
  }, [recuId]);

  useEffect(() => { if (recuId) charger(); }, [recuId, charger]);

  const supprimer = async (e) => {
    if (e.statut === 'paye') { toast.error("Échéance déjà payée : annulez d'abord le paiement avant de la supprimer"); return; }
    if (!window.confirm(`Supprimer l'échéance n°${e.numero_echeance} (${Number(e.montant || 0).toFixed(2)} EUR) ?\n\nLe reçu sera régénéré. Elle reste restaurable depuis le panneau Échéancier.`)) return;
    try {
      await axios.delete(`${API}/${recuId}/echeancier/${e.id}`, { headers: getAuthHeader() });
      toast.success('Échéance supprimée — reçu régénéré');
      charger();
    } catch (err) { toast.error(err.response?.data?.detail || 'Suppression impossible'); }
  };

  if (!echeances.length) return null;
  return (
    <div className="mt-4 bg-white rounded-lg border border-orange-200 p-3" data-testid="recu-valide-echeancier">
      <p className="text-xs font-semibold text-orange-700 mb-2 flex items-center gap-1"><Clock className="h-3.5 w-3.5" /> Échéancier ({echeances.length})</p>
      <div className="space-y-1">
        {echeances.map((e) => (
          <div key={e.id} className="flex items-center gap-2 text-xs" data-testid={`recu-valide-echeance-${e.id}`}>
            <span className="font-medium w-8">#{e.numero_echeance}</span>
            <span className="text-gray-500 w-24">{e.date_echeance ? new Date(e.date_echeance).toLocaleDateString('fr-FR') : '-'}</span>
            <span className="font-semibold">{Number(e.montant || 0).toFixed(2)} EUR</span>
            {e.statut === 'paye' && <Badge className="bg-emerald-700 text-white text-[9px] font-semibold">PAYÉE</Badge>}
            {peutSupprimer && (
              <button type="button" onClick={() => supprimer(e)} title={e.statut === 'paye' ? 'Payée : annulez le paiement avant suppression' : 'Supprimer cette échéance'}
                className={`ml-auto p-1 rounded ${e.statut === 'paye' ? 'text-gray-300 cursor-not-allowed' : 'text-red-600 hover:bg-red-100'}`}
                data-testid={`recu-valide-echeance-delete-${e.id}`}>
                <Trash2 className="h-3.5 w-3.5" />
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
